import {useCallback, useEffect, useState} from 'react';

export const clampZoom = value => Math.round(Math.min(3, Math.max(0.5, Number.isFinite(value) ? value : 1)) * 100) / 100;

export default function useZoomSettings() {
  const [zooms, setZooms] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('chwala.zoom') || '{}');
      return Object.fromEntries(['app', 'song', 'presentation'].map(scope => [scope, clampZoom(saved?.[scope] ?? 1)]));
    } catch {
      return {app: 1, song: 1, presentation: 1};
    }
  });
  useEffect(() => {
    try { localStorage.setItem('chwala.zoom', JSON.stringify(zooms)); } catch { /* Private browsing may disable storage. */ }
  }, [zooms]);
  const setZoom = useCallback((scope, value) => {
    setZooms(previous => ({...previous, [scope]: clampZoom(typeof value === 'function' ? value(previous[scope]) : value)}));
  }, []);
  return {zooms, setZoom};
}
